export const CLIENT_ID_LIST = {
  DG: 'oauth_dearborn_memberportal_APP00007076',
  IL: 'oauth_dearborn_il_memberportal_APP00007076',
  TX: 'oauth_dearborn_tx_memberportal_APP00007076',
  OK: 'oauth_dearborn_ok_memberportal_APP00007076',
  NM: 'oauth_dearborn_nm_memberportal_APP00007076',
  MT: 'oauth_dearborn_mt_memberportal_APP00007076',
  MI: 'oauth_dearborn_groupspecialtybenefits_memberportal_APP00007076'
};
